import React from 'react';
import {
  faMeh,
  faSmile,
  faTired,
  faFrown,
  faLaughBeam,
} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import {
  ColorStyleProps,
  Icon,
  IconProps,
  Text,
  parseColor,
  useTheme,
} from '@quality24/design-system';
import { Theme } from '@/inpatient-patient-pwa/types/theme';
import styles from './SmileyInputField.module.scss';

export interface Props {
  className?: string;
  value: number | undefined;
  onChange: (v: number) => void;
}
export interface IOption {
  label: string;
  value: number;
  icon: IconProps['icon'];
  backgroundColor: ColorStyleProps;
}

const options: Array<IOption> = [
  {
    label: 'rating.terrible',
    value: 1,
    icon: faTired,
    backgroundColor: 'nps0',
  },
  {
    label: 'rating.bad',
    value: 2,
    icon: faFrown,
    backgroundColor: 'nps3',
  },
  {
    label: 'rating.regular',
    value: 3,
    icon: faMeh,
    backgroundColor: 'nps5',
  },
  {
    label: 'rating.good',
    value: 4,
    icon: faSmile,
    backgroundColor: 'nps8',
  },
  {
    label: 'rating.great',
    value: 5,
    icon: faLaughBeam,
    backgroundColor: 'nps10',
  },
];

const SmileyInputField: React.FunctionComponent<Props> = ({
  className,
  value,
  onChange,
}: Props) => {
  const { t } = useTranslation();
  const { theme } = useTheme<Theme>();

  return (
    <div className={classNames(styles.wrapper, className)}>
      {options.map((option) => (
        <button
          key={option.label}
          type="button"
          className={classNames(styles.choice, 'smile', {
            inactive: value && value !== option.value,
          })}
          onClick={() => onChange(option.value)}
          style={{
            backgroundColor: parseColor(option.backgroundColor ?? 'primary', {
              theme,
            }),
            color: parseColor(option.backgroundColor ?? 'grayLight1', {
              theme,
            }),
          }}
        >
          {option.icon && <Icon icon={option.icon} size="md" color="white" />}
          {option.label && (
            <Text
              size="md"
              color="white"
              weight="semiBold"
              style={{
                width: '100px',
              }}
            >
              {t(option.label)}
            </Text>
          )}
        </button>
      ))}
    </div>
  );
};
export default SmileyInputField;
